import { render, staticRenderFns } from "./PThumbnail.vue?vue&type=template&id=110863e9&"
import script from "./PThumbnail.vue?vue&type=script&lang=js&"
export * from "./PThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports